import { Slot } from "radix-ui";
import type * as React from "react";
import { cn } from "@/lib/utils";

/** Rows divided by rules inside a Card, highlighted on hover. */
function List({ className, ...props }: React.ComponentProps<"ul">) {
  return <ul data-slot="list" className={cn("m-0 list-none p-0", className)} {...props} />;
}

function ListItem({ className, ...props }: React.ComponentProps<"li">) {
  return <li data-slot="list-item" className={cn("flex items-center gap-3 border-t border-border-muted px-4 py-2 first:border-t-0 hover:bg-muted", className)} {...props} />;
}

/** The bold first line of an issue-style row; usually wraps a link. */
function ListItemTitle({ className, asChild = false, ...props }: React.ComponentProps<"span"> & { asChild?: boolean }) {
  const Comp = asChild ? Slot.Root : "span";
  return <Comp data-slot="list-item-title" className={cn("text-base font-semibold text-foreground", className)} {...props} />;
}

/** The gray second line of an issue-style row. */
function ListItemMeta({ className, ...props }: React.ComponentProps<"div">) {
  return <div data-slot="list-item-meta" className={cn("mt-1 flex flex-wrap items-center gap-1 text-xs text-muted-foreground", className)} {...props} />;
}

function ListItemSeparator() {
  return <span className="text-faint">·</span>;
}

export { List, ListItem, ListItemMeta, ListItemSeparator, ListItemTitle };
